window.OrcamentoAbertoController = ControllerBase.extend({
    name: "OrcamentoAbertoController",

    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'CPF/CNPJ', prop: 'CpfCnpj' },
            { title: 'Nome', prop: 'Nome' }
        ],
        getData: function () {

            var cliente = this.cliente
                 ? this.cliente
                 : ControllerBase.instances['CadastroClienteController'].model;

            return this.toJS(cliente);
        },
    }),

    ajax: function() {

        return {
            url: "/Cliente/_OrcamentoAberto",
            type: "post",
            cache: false,
            contentType: "application/json",
            data: global.toJSONString({
                pesquisaOrcamentoAbertoContract: this.pesquisaOrcamentoAberto
            })
        };
    },

    renderizado: function() {

        $("#orcamento-aberto-container").removeClass("none").addClass("separador");

        this.OrcamentoAbertoView = this.showView({
            region: {
                name: "orcamentoAbertoViewRegion",
                selector: "#orcamento-aberto-region"
            },
            view: {
                type: OrcamentoAbertoView,
                args: {
                    collection: new OrcamentosAbertos(this.model)
                }
            }
        });
    }
});